import ScrolledIntoView from '@carvana/stc-scrolled-into-view';
import { useEffect, useState } from 'react';
import { getUserState } from '@carvana/core-auth';
import useExperimentBucket from '@carvana/experiment/useExperimentBucket';

import * as videoExperiment from '../experiments/video';
import recordAnalyticsEventMobile, { MobileAnalyticsEvents } from '../analytics/mobileAnalytics';
import { EventActions } from '../analytics/uiMetrics';
import useAnalyticEvent from '../shared/hooks/useAnalyticEvent';
import { EXPERIMENT_BUCKET } from '../experiments/video';
import AppraisalList from './AppraisalList/AppraisalList';
import CustomerReviews from './CustomerReview';
import FAQSection from './FAQs';
import { Container, Inner } from './Header';
import HeroFold from './HeroFold';
import HeroFoldVideo from './HeroFoldVideo';
import { Background } from './HeroFold/HeroFold.styles';
import StepsVideo from './StepsVideo';
import Steps from './Steps';
import TradeIn from './TradeIn';
import Worth from './Worth';
import HowItWorks from './HowItWorks';

const LandingPage = () => {
  const [isWindowLoaded, setIsWindowLoaded] = useState(false);
  const { recordGenericEvent } = useAnalyticEvent();
  const { isLoggedIn } = getUserState();

  const bucket = useExperimentBucket(videoExperiment.NAME);
  const isVideoExperiment = bucket === EXPERIMENT_BUCKET;

  useEffect(() => {
    if (!bucket) return;

    setIsWindowLoaded(true);
    recordGenericEvent('Landing Page', 'LandingPage', EventActions.Visited);
    recordAnalyticsEventMobile(MobileAnalyticsEvents.PageVisited, { pageName: 'Landing Page' });
  }, [bucket]);

  if (!bucket) return null;

  return (
    <Container>
      <Inner className="helios">
        {isWindowLoaded && isLoggedIn && <AppraisalList />}
        {!isVideoExperiment ? (
          <>
            <Background>
              <HeroFold />
              <Worth />
            </Background>
            <Steps />
            <ScrolledIntoView
              onFirstEnterView={() =>
                recordGenericEvent('Landing Page', 'Social Proof', EventActions.Scrolled)
              }
            >
              <CustomerReviews />
            </ScrolledIntoView>
            <FAQSection />
            <TradeIn />
          </>
        ) : (
          <>
            <HeroFoldVideo />
            <StepsVideo />
            <ScrolledIntoView
              onFirstEnterView={() =>
                recordGenericEvent('Landing Page', 'How It Works Video', EventActions.Scrolled)
              }
            >
              <HowItWorks />
            </ScrolledIntoView>
            <ScrolledIntoView
              onFirstEnterView={() =>
                recordGenericEvent('Landing Page', 'Social Proof', EventActions.Scrolled)
              }
            >
              <CustomerReviews videoExperiment />
            </ScrolledIntoView>
            <Worth videoExperiment />
            <FAQSection videoExperiment />
            <TradeIn videoExperiment />
          </>
        )}
      </Inner>
    </Container>
  );
};

export default LandingPage;
